import React from "react";
export const HashtagsContext = React.createContext();
